import React, { Component } from "react";
import { MSection, BoxDanger } from "components/misc";
import { CourseHelper, dateHelper, stringHelper } from "libs";
import { LESSONTRAINING_MODE, ROUTES } from "const";

export class CourseLessonSectionTable extends Component {

  goToLesson = (lesson) => {
    const { rCode } = this.props;
    if (lesson.lessonType === "live") {
      window.location = `${ROUTES.COURSE_LESSONLIVE_DETAIL}/${rCode}/${lesson.id}`;
    } else if (lesson.lessonType === "onsite") {
      window.location = `${ROUTES.COURSE_LESSONONSITE_DETAIL}/${rCode}/${lesson.id}`;
    } else if (lesson.lessonType === "training") {
      if (lesson.mode === LESSONTRAINING_MODE.ATTIVITA) {
        window.location = `${ROUTES.COURSE_LESSON_ACTIVITY}/training/${lesson.location}/${lesson.id}/${rCode}`;
      } else {
        window.location = `${ROUTES.COURSE_LESSONTRAINING_DETAIL}/${rCode}/${lesson.id}`;
      }
    }
  };

  render() {
    const {
      lessons,
      sections,
      analytics,
      userCourse,
      lessonCreditRecognition,
    } = this.props;

    if (lessons && lessons.length > 0 && sections && sections.length > 0) {

      // create thje headergroup for ATD and ATI 
      let minutesAT = 0;
      let percentAT = "0%";
      let lastUpdateAT = "";
      const analyticAT = analytics.filter(
        (analytics) => analytics.section === "ATD" || analytics.section === "ATI"
      );

      if (analyticAT && analyticAT.length > 0) {
        analyticAT.forEach(element => {
          minutesAT += parseInt(element.minutes);
          if (lastUpdateAT === "" || dateHelper.isAfter(element.lastUpdate, lastUpdateAT)) {
            lastUpdateAT = element.lastUpdate;
          }
        });

        const totaleMinutesAT = sections.filter(section => section.code === "ATD" || section.code === "ATI").reduce((total, section) => parseInt(total) + parseInt(section.totalMinutes), 0);
        let studentPercentAT = (minutesAT * 1.0) / totaleMinutesAT;
        if (studentPercentAT > 1) studentPercentAT = 1;
        percentAT = stringHelper.formatPercentage(studentPercentAT);       
      }

      const headerTitle = (CourseHelper.is60CFU(userCourse.courseCode) || CourseHelper.isUM36VC(userCourse.courseCode)) ? 'Tirocinio diretto e indiretto' : "Tirocinio indiretto";
      const headerGroupAT = (
        <MSection className="m-2">
          <h3>{headerTitle}</h3>
          <h5>Percentuale di frequenza: {stringHelper.formatPercentage(percentAT)}</h5> 
          <small>(ultimo aggiornamento {dateHelper.toITDateTime(lastUpdateAT)})</small>
        </MSection>
      );

      const table = sections.map((section) => {
        const sectionLessons = lessons.filter(
          (lesson) => lesson.section === section.code
        );
        
        // fnd analytics for this section
        const analytic = analytics.filter(
          (analytics) => analytics.section === section.code
        );
        let percent = "0%";
        let lastUpdate = "";
        if (analytic && analytic.length > 0) {
          const minutes = analytic[0].minutes;
          let studentPercent = (minutes * 1.0) / section.totalMinutes;
          if (studentPercent > 1) studentPercent = 1;
          percent = stringHelper.formatPercentage(studentPercent);
       
          lastUpdate = `(ultimo aggiornamento ${dateHelper.toITDateTime(
            analytic[0].lastUpdate
          )})`;
        }

        const addHeaderGroup = (section.code === "ATI") ? headerGroupAT : null;
        const isTirocinio = (section.code === "ATD" || section.code === "ATI") ? true : false;
        const isATD = (section.code === "ATD") ? true : false;

        if (sectionLessons.length > 0) {
          return (
            <div key={section.id}>
              {addHeaderGroup}
              <MSection key={section.id} className="m-2">
                <h4>
                  {section.title} [{section.code}]{" "}
                </h4>
                {!isTirocinio && (
                  <h5>
                    Percentuale di frequenza: {percent} <small>{lastUpdate}</small>
                  </h5>
                )}
                <hr />
                <table className="table table-striped">
                  <thead>
                    <tr>
                      {isATD ? <>
                       <th scope="col" colSpan={3}></th> </> 
                        : <>
                        <th scope="col">Data</th>
                        <th scope="col">Ora Inizio</th>
                         <th scope="col">Insegnamento</th>
                      </>}
                     
                      {!isTirocinio && <th scope="col">Docente</th>}
                      {!isTirocinio && <th scope="col">Tipo</th>}
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {sectionLessons.map((lesson, i) => {
                      let checkLessonCreditRecognition = [];
                      if (
                        lesson.lessonType === "onsite" &&
                        lessonCreditRecognition.length > 0
                      ) {
                        checkLessonCreditRecognition =
                          lessonCreditRecognition.filter((item) => {
                            return (
                              item.lessonId === lesson.id &&
                              item.registrationCode === this.props.rCode
                            );
                          });
                      }

                      let isRecognized = false;
                      // verify the creditRecognition
                      if (
                        checkLessonCreditRecognition.length > 0 ||
                        (lesson.creditRecognition &&
                          userCourse.creditRecognition &&
                          lesson.creditRecognition.includes(
                            userCourse.creditRecognition
                          ))
                      ) {
                        isRecognized = true;
                      }

                      return (
                        <tr key={`tr-${i}`}>
                          <td>
                            {lesson.date ? dateHelper.toITDate(lesson.date) : ""}
                          </td>
                          <td>
                            {lesson.hourStart
                              ? dateHelper.toShortTime(lesson.hourStart)
                              : ""}
                          </td>
                          <td>
                            {lesson.subject}
                            {isRecognized && (
                              <>
                                <br />
                                <span className="badge badge-secondary m-1">
                                  Attività riconosciuta e calcolata nella percentuale di presenza
                                </span>
                              </>
                            )}
                          </td>
                          {!isTirocinio && <td>{lesson.teacher}</td>}
                          {!isTirocinio && (
                            <td>
                              {lesson.lessonType === "live" && "Lezione telematica"}
                              {lesson.lessonType === "onsite" &&
                                "Lezione in presenza"}
                              {lesson.lessonType === "training" &&
                                "Tirocinio indiretto"}
                            </td>
                          )}
                          <td>
                            {(lesson.lessonType === "training" &&
                              lesson.mode === LESSONTRAINING_MODE.ATTIVITA &&
                              !lesson.location) ||
                              this.props.hideDetailsButton ? (
                              ""
                            ) : (
                              <button
                                className="btn btn-outline-primary"
                                onClick={() => this.goToLesson(lesson)}
                              >
                                Dettagli
                              </button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </MSection>
            </div>
          );
        }
      });

      return <div>{table}</div>;
    } else {
      return (
        <MSection className="m-2">
          <BoxDanger>Non sono presenti attività formative.</BoxDanger>
        </MSection>
      );
    }
  }
}
